// Next Availability Custom Element (for product pages)
if (!customElements.get('next-availability')) {
  customElements.define(
    'next-availability',
    class NextAvailability extends HTMLElement {
      constructor() {
        super();

        this.productName = this.dataset.productName;
        if (!this.productName) return;

        this.headingEl = this.querySelector('.next-availability__heading');
        this.loadingEl = this.querySelector('.next-availability__loading');
        this.resultEl = this.querySelector('.next-availability__result');
        this.textEl = this.querySelector('.next-availability__text');

        this.fetchNextAvailability();
      }

      async fetchNextAvailability() {
        const WORKER_URL = 'https://soulupworker.geeks2connect.workers.dev';
        const url = `${WORKER_URL}/next-availability?product_name=${encodeURIComponent(this.productName)}`;

        try {
          const response = await fetch(url);
          if (!response.ok) throw new Error('Worker request failed');
          const data = await response.json();

          if (!data.available) {
            // Show "Available" for products without appointments configured
            if (data.reason === 'not_found' || data.reason === 'no_appointments' || data.reason === 'no_slots') {
              this.renderResult({ available: true, display_text: 'Available', hideHeading: true });
              return;
            }
            this.renderResult({ available: false, reason: 'error' });
            return;
          }

          this.renderResult({
            available: true,
            date: data.date,
            time: data.time,
            day_name: data.day_name,
            date_formatted: data.date_formatted
          });
        } catch (error) {
          console.error('[NextAvailability] Error:', error);
          this.loadingEl.setAttribute('hidden', '');
          this.textEl.textContent = 'Available';
          this.resultEl.removeAttribute('hidden');
        }
      }

      renderResult(data) {
        this.loadingEl.setAttribute('hidden', '');

        if (!data.available) {
          this.textEl.textContent = 'Available';
          this.textEl.classList.add('next-availability__text--no-slots');
          this.resultEl.removeAttribute('hidden');
          return;
        }

        // If custom display text is provided (e.g., "Available")
        if (data.display_text) {
          this.textEl.textContent = data.display_text;
          this.resultEl.removeAttribute('hidden');
          // Hide heading when showing "Available"
          if (data.hideHeading && this.headingEl) {
            this.headingEl.setAttribute('hidden', '');
          }
          return;
        }

        // Format time: convert "05:30PM" to "5:30 PM"
        const timeFormatted = data.time.replace(/(\d{2}):(\d{2})(AM|PM)/i, '$1:$2 $3').replace(/^0/, '');

        this.textEl.textContent = `${data.day_name}, ${data.date_formatted} at ${timeFormatted}`;
        this.resultEl.removeAttribute('hidden');
      }
    }
  );
}

// Next Availability Badge Custom Element (for product cards)
if (!customElements.get('next-availability-badge')) {
  customElements.define(
    'next-availability-badge',
    class NextAvailabilityBadge extends HTMLElement {
      constructor() {
        super();
        this.productName = this.dataset.productName;
        this.sectionId = this.dataset.sectionId;
        this.productId = this.dataset.productId;
        if (!this.productName) return;
        this.fetchAvailability();
      }

      async fetchAvailability() {
        const WORKER_URL = 'https://soulupworker.geeks2connect.workers.dev';
        const url = `${WORKER_URL}/next-availability?product_name=${encodeURIComponent(this.productName)}`;

        try {
          const response = await fetch(url);
          if (!response.ok) throw new Error('Worker request failed');
          const data = await response.json();

          const loadingEl = this.querySelector('.next-availability-badge__loading');
          const textEl = this.querySelector('.next-availability-badge__text');

          if (!data.available) {
            if (loadingEl) loadingEl.setAttribute('hidden', '');
            if (textEl) {
              textEl.textContent = 'Available';
              textEl.removeAttribute('hidden');
            }
            return;
          }

          if (data.display_text) {
            if (loadingEl) loadingEl.setAttribute('hidden', '');
            if (textEl) {
              textEl.textContent = data.display_text;
              textEl.removeAttribute('hidden');
            }
            this.classList.add('next-availability-badge--available');
            return;
          }

          const timeFormatted = data.time.replace(/(\d{2}):(\d{2})(AM|PM)/i, '$1:$2 $3').replace(/^0/, '');
          const displayText = `${data.day_name}, ${data.date_formatted} at ${timeFormatted}`;

          if (loadingEl) loadingEl.setAttribute('hidden', '');
          if (textEl) {
            textEl.textContent = displayText;
            textEl.removeAttribute('hidden');
          }
          this.classList.add('next-availability-badge--available');
        } catch (error) {
          console.error('[NextAvailabilityBadge] Error:', error);
          const loadingEl = this.querySelector('.next-availability-badge__loading');
          const textEl = this.querySelector('.next-availability-badge__text');
          if (loadingEl) loadingEl.setAttribute('hidden', '');
          if (textEl) {
            textEl.textContent = 'Available';
            textEl.removeAttribute('hidden');
          }
        }
      }
    }
  );
}
